import React, { useState, useEffect, useRef } from 'react';
import getCategories from '../../services/getCategories';
import Sugerencias from '../sugerencias/Sugerencias';

/**
 * Componente BusquedaForm
 * Renderiza el input de búsqueda con selector de categorías, soporte para sugerencias y reset de búsqueda.
 */
export default function BusquedaForm({
  query,
  category,
  onQueryChange,
  onCategoryChange,
  token,
  setQuery,
  retryCount,
  setToken,
  setErrorService,
  setRetrySearch,
  setRetryCount,
  sessionId,
  errorService,
  isMobile,
  setData
}) {
  // Estados locales
  const [text, setText] = useState(query);
  const [textNew, setTextNew] = useState();
  const [categories, setCategories] = useState();
  const [showSugerencias, setShowSugerencias] = useState(false);
  const [hasFocus, setHasFocus] = useState(false);
  const [listaSugerencias, setListaSugerencias] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const inputRef = useRef(null);

  /**
   * Obtener listado de categorías desde el servicio.
  */
  useEffect(() => {
    getCategories()
      .then(setCategories)
      .catch((error) => {
        console.error("Error al obtener las categorías:", error);
      });
  }, []);

  /**
   * Actualizar estado local al recibir nueva query desde props.
  */
  useEffect(() => {
    if (query !== text) {
      setText(query);
    }
  }, [query])

  /**
   * Detecta si mostrar sugerencias al escribir.
  */
  useEffect(() => {
    setShowSugerencias(text.length >= 3);
  }, [text])

  /**
   * Agrega y remueve listeners de focus/blur del input.
  */
  useEffect(() => {
    const inputElement = inputRef.current;
    if (!inputElement) return;

    const handleFocus = () => setHasFocus(true);
    const handleBlur = () => setHasFocus(false);

    inputElement.addEventListener('focus', handleFocus);
    inputElement.addEventListener('blur', handleBlur);

    // Limpiar eventos al desmontar el componente
    return () => {
      inputElement.removeEventListener('focus', handleFocus);
      inputElement.removeEventListener('blur', handleBlur);
    };
  }, []);

  /**
   * Manejador de cambio de texto en el input.
  */
  const handleQueryChange = (event) => {
    const value = event.target.value;
    setText(value);

    if (value === '') {
      handleReset();
    }
  };

  /**
   * Manejador de búsqueda al presionar Enter.
  */
  const handleKeyDown = (event) => {
    const key = event.key;

    if (key === 'Enter' && selectedIndex === -1) {
      event.preventDefault();
      const queryToUse = textNew?.trim().length > 0 ? textNew : text;
      onQueryChange(queryToUse);
      setShowSugerencias(false);
    }
    
    if (key === 'Backspace') {
      setSelectedIndex(-1);
      setTextNew('');
    }
  };

  /**
   * Ejecutar búsqueda manual desde el botón.
  */
  const handleSearch = () => {
    onQueryChange(text);
    setShowSugerencias(false);
  };

  /**
   * Limpiar el formulario de búsqueda y sugerencias.
  */
  const handleReset = () => {
    setText('');
    setTextNew('');
    onQueryChange('');
    setData(null);
    setListaSugerencias([]);
    setSelectedIndex(-1);
  };

  return (
    <header className='w-equipo'>
      <div className="search-container">
        <input
          type="text"
          id="query"
          value={text}
          onChange={handleQueryChange}
          onKeyDown={handleKeyDown}
          placeholder="Buscar..."
          className="search-input"
          autoComplete='off'
          ref={inputRef}
          style={{
            fontSize: '16px',
            WebkitOverflowScrolling: 'touch',
            overflowX: 'auto',
            whiteSpace: 'normal',
            textOverflow: 'clip'
          }}
        />

        <button id="buscarBtn" onClick={handleSearch} className="search-button" aria-label="Buscar" title="Buscar">
          <span className="item-search" aria-hidden="true" />
        </button>

        {/* Botón para resetear la selección */}
        <button
          type="button"
          className="reset-button"
          onClick={() => handleReset()}
          aria-label="Limpiar búsqueda"
          title="Limpiar búsqueda"
          id="resetBtn"
        />

        {/* Muestra sugerencias si aplica */}
        {text && String(text).trim().length >= 3 && showSugerencias && (
          <Sugerencias
            palabra={text}
            setText={setText}
            setTextNew={setTextNew}
            setShowSugerencias={setShowSugerencias}
            inputRef={inputRef}
            token={token}
            hasFocus={hasFocus}
            setQuery={setQuery}
            retryCount={retryCount}
            setToken={setToken}
            setErrorService={setErrorService}
            setRetrySearch={setRetrySearch}
            setRetryCount={setRetryCount}
            sessionId={sessionId}
            errorService={errorService}
            category={category}
            isMobile={isMobile}
            onQueryChange={onQueryChange}
            listaSugerencias={listaSugerencias}
            setListaSugerencias={setListaSugerencias}
            setSelectedIndex={setSelectedIndex}
            selectedIndex={selectedIndex}
          />
        )}
      </div>

      {/* <div className="tags-container">
        {categories && categories.map((cat, index) => (
          <label key={cat.id + cat.value}>
            <input
              type="radio"
              name="category"
              value={cat.value}
              checked={
                (index === 0 && cat.value.trim() === '' && category.trim() === '') ||
                (index !== 0 && String(category).trim() === String(cat.value).trim())
              }
              onChange={onCategoryChange}
            />
            <span className="tag-label">{cat.label}</span>
          </label>
        ))}
      </div> */}

    </header>
  );
}

